export default __webpack_public_path__ + "static/media/thumbnail.c672338b.png";